// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RHIO","col":"styles_col__jakcg"};